type EnvKey = "REACT_APP_API_CONFIG" | "REACT_APP_API_HOST";

function required(key: EnvKey): string {
  const value = process.env[key];
  if (!value) {
    throw new Error(
      `[env] Missing ${key}. Please check .env file (remember to prefix REACT_APP_).`
    );
  }
  return value;
}

export const API_CONFIG = required("REACT_APP_API_CONFIG");
export const API_HOST = required("REACT_APP_API_HOST");
